import React from "react";
import { RightArrowIcon } from "../../Icons";

const TertiaryButton = ({ text, ...props }) => {
  return (
    <div className="flex items-center">
      <button
        className="flex bg-transparent underline px-3 py-2 rounded-full hover:bg-background-hover disabled:bg-small-dsiabled-btn-bg/50 text-primary-600 text-sm font-medium transition-all duration-300 ease-in-out"
        {...props}
      >
        {text}
        <RightArrowIcon />
      </button>
    </div>
  );
};

export default TertiaryButton;
